export default "__VITE_ASSET__CCCQh5$P__"